// src/app/directives/custom-email-validator.directive.ts (or whatever it's called)

import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';
import { ValidationUtils } from '../Util/validation.utils';

@Directive({
  selector: '[customEmail]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: CustomEmailValidatorDirective,
    multi: true
  }]
})
export class CustomEmailValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    // If empty or whitespace → let 'required' handle it
    if (!value || value.trim() === '') {
      return null;
    }

    const isValid = ValidationUtils.isValidEmail(value);
    return isValid ? null : { email: true };
  }
}